import { Fragment, useState } from 'react'
import { useGetDriverQuery, useGetQuickPaymentRequestInfoQuery } from '../../../store/slices/backoffice.slice'
import { useLocation } from 'react-router-dom';
import { PROD_BASEURL } from '../../../utils/services/axios.service';
import PageLayout from '../../../components/layouts/PageLayout';
import { MenuType } from '../../../utils/helpers/constants';
import { Container, Row } from 'react-bootstrap';
import { DropDown, DropDownItem } from '../../../components/modules/DropDown';
import LoanRequestCard from './misc/LoanRequestCard';
import QuickPayRequestBreakdown from './misc/QuickPayRequestBreakdown';
import ActionPromptModal from '../../../components/modals/ActionPromptModal';
import { ActionPromptEnum } from '../../../interfaces/enums';
// import SupportingDocument from './misc/SupportingDocument';



const QuickPayRequestInfo = () => {
  const [rejectRequestRender, setRejectRequestRender] = useState(false);
  const [approveRequestRender, setApproveRequestRender] = useState(false);
  const location = useLocation();

  const reference = window.location.hostname === PROD_BASEURL ? "TRU_Z9WE" : "TRU_H0D4"
  const { data: request, isLoading, } = useGetQuickPaymentRequestInfoQuery({ reference: reference, filter: location.state?.id });
  const { data: driver, isLoading: isLoadingDriver, } = useGetDriverQuery(location.state.driver_id);


  const closeRejectRequestRender = () => setRejectRequestRender(false);
  const closeApproveRequestRender = () => setApproveRequestRender(false);


  const rejectQuickPayRequestModal = rejectRequestRender ?
    <ActionPromptModal onchange={closeRejectRequestRender} type={ActionPromptEnum.REJECT_QUICK_PAY_REQUEST}
      props={request?.data[0]?.id} confirmation={request?.data[0]?.id} /> : null;
  const approveQuickPayRequestModal = approveRequestRender ?
    <ActionPromptModal onchange={closeApproveRequestRender} type={ActionPromptEnum.APPROVE_QUICK_PAY_REQUEST}
      props={request?.data[0]?.id} confirmation={request?.data[0]?.id} /> : null;

  return (
    <PageLayout active={MenuType.SUPPLY} backEnabled loading={isLoading || isLoadingDriver}
      title={`Quick Payment Request Info`}>
      {rejectQuickPayRequestModal}
      {approveQuickPayRequestModal}
      <Container fluid>
        <div className="d-flex justify-content-end gap-2 mb-3">
          {(request && request?.data && request?.data[0].status === "PENDING") &&
            <Fragment>
              {/*{(*/}
              {/*    profile.permissions?.["can-approve-quick-pay-request"]*/}
              {/*    || profile.permissions?.["can-deny-quick-pay-request"]*/}
              {/*    || profile.permissions?.["can-delete-quick-pay-request"]*/}
              {/*  ) &&*/}
              <DropDown buttonText="Actions" variant="primary">
                {/*{profile.permissions?.["can-approve-quick-pay-request"] &&*/}
                <DropDownItem text="Approve Quick-Pay Request"
                  onclick={() => setApproveRequestRender(true)}
                />
                {/*}*/}
                {/*{profile.permissions?.["can-deny-quick-pay-request"] &&*/}
                <DropDownItem text="Reject Quick-Pay Request" className="text-danger"
                  onclick={() => setRejectRequestRender(true)} />
                {/*}*/}
                {/*{profile.permissions?.["can-delete-quick-pay-request"] &&*/}
                {/* <DropDownItem text="Delete Top-Up Request" className="text-bg-danger" 
                // loading={isLoadingDelete}
                  onclick={() => console.log("1")} /> */}
                {/*}*/}
              </DropDown>
              {/*}*/}
            </Fragment>
          }
          {/*{(profile.permissions?.["can-repay-quick-pay-request"] && request && request.data*/}
          {/*    && (request.data.status === "DISBURSED" || request.data.status === "REPAYMENT")) &&*/}
          {/*	<button className="btn btn-primary pointer-event" onClick={() => setRepayRequestRender(true)}>*/}
          {/*		<i className="bx bxs-credit-card me-1"></i> Repay Top-Up*/}
          {/*	</button>*/}
          {/*}*/}
          {/* {(request && request.data && (request.data.status === "DISBURSED" || request.data.status === "REPAYMENT")) &&
            <>
              <button className="btn btn-primary pointer-event" onClick={() => setShowRepaymentOptions(!showRepaymentOptions)}>
                <i className="bx bxs-credit-card me-1"></i> Repay Top-Up
              </button>
              {showRepaymentOptions && (
                <div className="position-absolute w-[15%] bg-white shadow-sm border rounded " style={{ zIndex: 1000, right: "155px", top: "140px" }}>
                  {repaymentOptions.map((option, index) => (
                    <div
                      key={index}
                      className="px-3 py-2 cursor-pointer hover:bg-light"
                      onClick={() => handleOptionClick(option.value)}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </>
          } */}

          {/* <button className="btn btn-secondary pointer-event" onClick={() => setLoanCanvasRender(true)}>
            <i className="bx bx-map me-1"></i> Status History
          </button> */}
        </div>
        <Row className="h-100">
          <LoanRequestCard profile={driver?.data?.driver ?? {}} />
          <QuickPayRequestBreakdown request={request?.data ?? {}}
            extras={driver?.data?.driver.extras ?? {}}
          />
          {/* <SupportingDocument profile={driver?.data?.driver ?? {}}
            dynamicFields={driver?.data?.driver.extras ?? []} 
            /> */}
        </Row>
      </Container>
    </PageLayout>
  )
}

export default QuickPayRequestInfo